import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../../../../const'
import DateAdapter from '../../../../utils/DateAdapter'
import EvaluacionDisciplinaOperativa from '../../domain/entities/EvaluacionDisciplinaAdministrativa'

export default class EvaluacionDisciplinaOperativaAdapter {
  static toDomain(evaluacionDto) {
    const evaluacion = new EvaluacionDisciplinaOperativa(evaluacionDto.fk_idPersonal)
    evaluacion.id = evaluacionDto.id
    evaluacion.idEvaluado = evaluacionDto.fk_idPersonal
    evaluacion.evaluado = evaluacionDto.Personal
    evaluacion.idEvaluador = evaluacionDto.fk_idPersonalEvaluador
    evaluacion.evaluador = evaluacionDto.PersonalEvaluador
    evaluacion.idPeriodicidad = evaluacionDto.fk_idPeriodicidad
    evaluacion.periodicidad = evaluacionDto.CatPeriodicidad?.title || ''
    evaluacion.fechaInicio = new DateAdapter(evaluacionDto.fechaInicial, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.fechaConclusion = new DateAdapter(evaluacionDto.fechaFin, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.fechaAplicacion = new DateAdapter(evaluacionDto.fechaAplicacion, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.instanciaInformadora = evaluacionDto.instanciaInforma
    evaluacion.idEstatus = evaluacionDto.fk_idCatEstatusEvaluacion
    evaluacion.estatus = evaluacionDto.CatEstatusEvaluacion?.title || ''
    evaluacion.procedimientos = evaluacionDto.procedimientos.map((procedimiento) => ({
      id: procedimiento.id ?? null,
      idProcedimiento: procedimiento.fk_idCatProcedimiento,
      idEstatus: procedimiento.fk_idCatEstatusProcedimiento,
      estatusProcedimiento: procedimiento.CatEstatusProcedimiento?.title || '',
      numero: procedimiento.numero,
      fecha: new DateAdapter(procedimiento.fecha, API_DATE_FORMAT).toUiSupportedFormat(),
      motivo: procedimiento.motivo,
      descripcion: procedimiento.descripcion,
      resolucion: procedimiento.resolucion,
      estatus: true,
    }))

    return { ...evaluacion }
  }

  static toDto(evaluacion) {
    return {
      id: evaluacion.id,
      fk_idPeriodicidad: evaluacion.idPeriodicidad,
      instanciaInforma: evaluacion.instanciaInformadora,
      fechaInicial: new DateAdapter(evaluacion.fechaInicio, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaFin: new DateAdapter(evaluacion.fechaConclusion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaAplicacion: new DateAdapter(evaluacion.fechaAplicacion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fk_idPersonalEvaluado: evaluacion.idEvaluado,
      fk_idPersonalEvaluador: evaluacion.idEvaluador,
      fk_idCatEstatusEvaluacion: evaluacion.idEstatus,
      procedimientos: evaluacion.procedimientos.map((procedimiento) => ({
        ...(!!procedimiento.id && { id: procedimiento.id, estatus: procedimiento.estatus }),
        fk_idCatProcedimiento: procedimiento.idProcedimiento,
        fk_idCatEstatusProcedimiento: procedimiento.idEstatus,
        numero: procedimiento.numero,
        fecha: new DateAdapter(procedimiento.fecha, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
        motivo: procedimiento.motivo,
        descripcion: procedimiento.descripcion,
        resolucion: procedimiento.resolucion,
      })),
    }
  }
}
